import { render, staticRenderFns } from "./NutrientsTable.vue?vue&type=template&id=4bff0b9b&"
import script from "./NutrientsTable.vue?vue&type=script&lang=js&"
export * from "./NutrientsTable.vue?vue&type=script&lang=js&"
import style0 from "./NutrientsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports